import React, { useMemo } from 'react';
import Icon from '../../../components/AppIcon';

const SentimentAnalysisChart = ({ reviews }) => {
  const sentimentData = React.useMemo(() => {
    if (!reviews || reviews?.length === 0) return null;

    const positive = reviews?.filter(r => r?.starRating >= 4)?.length || 0;
    const neutral = reviews?.filter(r => r?.starRating === 3)?.length || 0;
    const negative = reviews?.filter(r => r?.starRating <= 2)?.length || 0;
    const total = reviews?.length || 1;

    return {
      positive: { count: positive, percentage: (positive / total) * 100 },
      neutral: { count: neutral, percentage: (neutral / total) * 100 },
      negative: { count: negative, percentage: (negative / total) * 100 }
    };
  }, [reviews]);

  if (!sentimentData) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-6">
        <div className="flex items-center gap-2 mb-6">
          <Icon name="PieChart" size={20} className="text-emerald-600" />
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Sentiment Analysis</h3>
        </div>
        <p className="text-gray-500 dark:text-gray-400 text-center py-8">No sentiment data available</p>
      </div>
    );
  }

  const sentiments = [
    { label: 'Positive', data: sentimentData?.positive, color: 'bg-emerald-500', textColor: 'text-emerald-600', icon: 'ThumbsUp' },
    { label: 'Neutral', data: sentimentData?.neutral, color: 'bg-yellow-500', textColor: 'text-yellow-600', icon: 'Minus' },
    { label: 'Negative', data: sentimentData?.negative, color: 'bg-red-500', textColor: 'text-red-600', icon: 'ThumbsDown' }
  ];

  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 p-6">
      <div className="flex items-center gap-2 mb-6">
        <Icon name="PieChart" size={20} className="text-emerald-600" />
        <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Sentiment Analysis</h3>
      </div>

      <div className="space-y-4">
        {sentiments?.map((sentiment) => (
          <div key={sentiment?.label}>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <Icon name={sentiment?.icon} size={16} className={sentiment?.textColor} />
                <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{sentiment?.label}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold text-gray-900 dark:text-white">{sentiment?.data?.count}</span>
                <span className="text-xs text-gray-500 dark:text-gray-400">({sentiment?.data?.percentage?.toFixed(1)}%)</span>
              </div>
            </div>
            <div className="h-3 bg-gray-100 dark:bg-slate-700 rounded-full overflow-hidden">
              <div
                className={`h-full ${sentiment?.color} transition-all duration-500`}
                style={{ width: `${sentiment?.data?.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SentimentAnalysisChart;